import React from "react";
import ReactDOM from "react-dom";
import "./InterestedSuccessModal.css";

const InterestedSuccessModal = ({ isOpen, onClose, title, message }) => {

  if (!isOpen) {
    return null;
  }

  const handleClose = () => {
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const modalContent = (
    <div
      className="success-modal-overlay"
      onClick={handleOverlayClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: " rgba(255, 255, 255, 1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2147483647,
        pointerEvents: "auto",
        opacity: 1,
        visibility: "visible",
      }}
    >
      <div
        className="success-modal-container"
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{
          position: "relative",
          background: " rgba(255, 255, 255, 1)",
          borderRadius: "16px",
          maxWidth: "450px",
          width: "90%",
          zIndex: 2147483647,
          pointerEvents: "auto",
          opacity: 1,
          visibility: "visible",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5)",
        }}
      >
        <div
          className="success-modal-content"
          style={{ padding: "40px 30px", textAlign: "center" }}
        >
          <div
            className="success-modal-icon"
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "24px",
            }}
          >
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" fill="#0e6a36" />
              <path
                d="M9 12l2 2 4-4"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h2
            className="success-modal-title"
            style={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#ffffff",
              margin: "0 0 16px 0",
              fontFamily: '"Outfit", sans-serif',
            }}
          >
            {title}
          </h2>

          <p
            className="success-modal-message"
            style={{
              fontSize: "16px",
              color: "#000",
              lineHeight: 1.6,
              margin: "0 0 32px 0",
              fontFamily: '"Outfit", sans-serif',
            }}
          >
            {message}
          </p>

          <button
            className="success-modal-button"
            onClick={handleClose}
            style={{
              background: "#0e6a36",
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: "14px 48px",
              fontSize: "16px",
              fontWeight: 600,
              cursor: "pointer",
              width: "100%",
              maxWidth: "200px",
              fontFamily: '"Outfit", sans-serif',
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default InterestedSuccessModal;
